import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../i18n';

const EvenTypeButton = (props) => {
    const { t } = useTranslation();
    const {
        handleFilters,
        filters,
        settings,
        typeEvent,
        data,
        eventsCount,
        isDesktop,
        isMobile } = props;

    const getItemColor = () => {
        return props.data.settings.items_color || props.data.settings.organization_items_color || '#FF585D';
    }
    return (
        <div
            className={`${isDesktop ? 'p-1 min-w-100' : isMobile ? 'p-2 min-w-160' : 'p-2 min-w-133'} mr-3 cursor-pointer rounded-md whitespace-nowrap ${props.filters.type === typeEvent ? 'text-white font-bold' : 'text-black font-light'}`}
            style={{
                backgroundColor: `${props.filters.type === typeEvent ? getItemColor() : '#E0E0E0'}`,
            }}
        >
            <div
                className={`text-center ${isDesktop ? 'text-sm' : isMobile ? 'text-xl' : 'text-lg'}`}
                onClick={() => { handleFilters('type', typeEvent) }}
            >
                {t(typeEvent)} ({typeEvent === 'all' ? props.data.events.length : typeEvent === 'past' ? eventsCount(props.data.events, 'past') : eventsCount(props.data.events, 'upcoming')})
            </div>
        </div>
    )
}

export default EvenTypeButton;